<template>
  <div class="set">
    <el-menu
      :default-active="active"
      class="set-nav"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item class="" index="AutoSet">班次设置</el-menu-item>
      <el-menu-item class="" index="AboutNew">系统设置</el-menu-item>
    </el-menu>

    <div class="set-con">
      <AutoSet v-if="active == 'AutoSet'" />
      <AboutNew v-if="active == 'AboutNew'" />
    </div>
  </div>
</template>

<script>

import AutoSet from "@/views/autoSet/index.vue";
import AboutNew from "@/views/aboutNew/index.vue";
export default {
  name: "Page",
  components: { AutoSet, AboutNew },
  data() {
    return {
      active: "AutoSet",
    };
  },
  mounted() {},
  methods: {
    handleSelect(index) {
      this.active = index;
    },
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
